/**
 * Resolves the Player_Tags row id from a tag/clip object.
 *
 * The tag-producing database functions (s4u_new_get_players_tags,
 * s4u_new_get_opponent_tags) expose that id as `player_tag_id`, and
 * normalizeTagData passes it through untouched. `tag_id` is accepted only as a
 * fallback for callers that build tag objects themselves.
 *
 * The `id` column present in those result sets is deliberately NOT used: it is
 * a different id, and submitting it would correct the wrong clip.
 *
 * @param {Object} tag - A tag/clip object
 * @returns {number|null} The Player_Tags id, or null when the tag carries none
 */
export const getPlayerTagId = (tag) => {
    if (!tag) return null;

    const raw = [tag.player_tag_id, tag.tag_id].find((value) => value !== undefined && value !== null && value !== '');
    const id = Number(raw);

    return Number.isFinite(id) ? id : null;
};
